import { EventEmitter, Output,Component,  OnInit, ElementRef,  Renderer2, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { login } from '../../../models/login/login.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService, MessagesService,  SpinnerService } from 'src/app/services/service.index';
import { RequestMessage } from '../../../models/common/requestMessage.model';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment.prod';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { CaptchaData, UserModel } from 'src/app/models/auth/_models/user.model';
import { Subscription, Observable, catchError, throwError, Subject } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { TokenRequest } from 'src/app/models/auth/_models/auth.model';
import { HttpClient } from '@angular/common/http';
import { AuthHTTPService } from 'src/app/models/auth/_services/auth-http/auth-http.service';
// src\app\models\auth\_services\auth-http\auth-http.service.ts
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit , OnDestroy{
  @Output() close = new EventEmitter<void>();
  private unsubscribe$ = new Subject<void>(); // Para manejar la limpieza de suscripciones
  today: number = Date.now();
  public ambientes: any = {};
  public mostrarAmbientes: boolean = false;
  public showPassword: boolean = false;
  mostrarContrasena = false;
  showBack = false;
  ambienteDefault: any;
  public auth2: any;
  public isIpad: boolean = /iPad/.test(navigator.userAgent);
  private unsubscribe: Subscription[] = [];
  tokenRequest: TokenRequest={
    Token:''
  }; 
  loadLogin: boolean = false;

  // Google
  showPasswordBtn: boolean = true;
  urlRedirect: string = '';
  // urlSaml= environment.urlSaml;
  showGoogleBtn: boolean = false;
  showUsuario: boolean = true;
  mostrarSend: boolean = true;
  returnUrl: string;
  urlTree: any;
  token: any;
  methodId: any;
  loading: boolean = false;
  version: string;
  positionDefault: any;
  guidSessio: any;
  Tknsession: any;
  tokenSessio: any;
  sessionData: any;
  popupPosition = { my: 'center', at: 'center', of: window };
  datalogin: login = {
    userName: '',
    password: '',
    companyId: '',
    ambiente: ''
  };
  requestMenu: RequestMessage = {
    usuario: '',
    producto: '',
    token: '',
    queryInfo: ''
  };

  captchaData: CaptchaData = new CaptchaData();
  image: any;
  imageV: Observable<boolean>;
  body: { estado: string; evento: string; } | undefined;
  filtroQbeForms: any;
  // fin Google

  showFormUser: boolean = false;
  tokenUser: string = '';
  dataRemember: any = {};
  year: number;
  captchavalueseven: string;
  RcaptchaSeven: Observable<boolean>;
  ValueRcaptchaSeven = false;
  capchat$: any;
  imglogin: any;
  RcaptchaGoogle: any;
  siteKey: any;
  authentication: any;
  autenticacionOauth: any;
  autenticacionAzure: any;
  activeDirectory: any;
  activeLDPA: any;
  autenticationADpassword: any;
  valueatentication: string;
  user: string;
  pass: string;
  mail: string;
  sessionval: Promise<void>;
  qrCodeUrl: string | null = null;
  session: boolean;
  ruta: string;
  valout: any;
  popupVisible: boolean;

  qrCodeUri: string = '';
  secret: string = '';
  username: string = '';
  code: any;
  message: string;
  DfaGoogle: string;
  DfaMicrosoft: string;
  popupVisible2sfGoogle: boolean;
  messageStyle: string;
  private currentIndex = 0;
  private intervalId!: any;
  Vtp: string;
  popuplicen = false;
  accepted = false;

keyUtf8 = 'sev3nERP!9a7bC2d'; 
ivUtf8  = 'Iv7S3vErN9p#4X1!'; 

 key = CryptoJS.enc.Utf8.parse(this.keyUtf8);
 iv  = CryptoJS.enc.Utf8.parse(this.ivUtf8);

  constructor(
    private formBuilder: FormBuilder,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private _commonServices: CommonService,
    // private formService: FormIOService,
    private el: ElementRef,
    private messagesService: MessagesService,
    private authService: AuthService,
    private _spinnerService: SpinnerService,
    public domSanitizer: DomSanitizer,
    private reCaptchaService: ReCaptchaV3Service,
    private renderer: Renderer2,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private AuthHTTPService:AuthHTTPService
  ) {
    this.loginForm = this.formBuilder.group({
      usuario: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      ambiente: ['', Validators.required]
    });
  }
  ////#region Atributos
  public loginForm: FormGroup;


  ////#endregion
  get usuario() {
    return this.loginForm.get('usuario');
  }
  get password() {
    return this.loginForm.get('password');
  }

  get ambiente() {
    return this.loginForm.get('ambiente');
  }



  async ngOnInit() {
    // this.loading = true;
 
    const style = this.renderer.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
    .grecaptcha-badge {
      display: none !important;
  }
    `;
    this.renderer.appendChild(document.head, style);

     this.token = this.activatedRoute.snapshot.queryParams['token'];
     this.tokenUser = this.activatedRoute.snapshot.queryParams['token'];
 

    this.Vtp = localStorage.getItem('View');

    if(this.Vtp=='preview'){
      this.token ='';
      this.tokenUser='';
      localStorage.removeItem('View');
    }
    
    this.getcaptcha();
   
    await this.loadimgloggin();
    this.version = environment.appVersion;
   if (!!this.token) {
      this.showFormUser = true;
    }
    else {
      this.showFormUser = false;
    }

    // this.showUsuario=true;
    // this.mostrarContrasena = true;
    let today = new Date();
    this.year = today.getFullYear();

   
    // this._spinnerService.close();
    // this.returnUrl = this.route.snapshot.queryParams['returnUrl'.toString()] || '/';
  }


  ngOnDestroy() {
    this.unsubscribe$.next(); // Notifica a los observables que se complete
    this.unsubscribe$.complete(); // Completa el Subject
  }

  async loadimgloggin() {


    this.authService.loadimgloggin().subscribe(
      resp => {
        this.imglogin = resp
        if (resp.length > 0) {
       
          // for (let key of  this.imglogin.length ){
          for (let key = 0; key < this.imglogin.length; key++) {

            this.imglogin[key].imagen = this.UrlImagen(this.imglogin[key].imagen)
          }
          this.cdr.detectChanges();
          this.startCarousel(5000); // cada 5s
        }
      });

  }
  // Métodos para los controles
  prev() {
    this.moveTo(this.currentIndex - 1);
  }
  next() {
    this.moveTo(this.currentIndex + 1);
  }
  goToSlide(i: number) {
    this.moveTo(i);
  }

  private moveTo(newIndex: number) {
    const container = document.querySelector('#carouselExampleIndicators .carousel-inner');
    const items = container?.querySelectorAll('.carousel-item') || [];
    if (!items.length) return;

    items[this.currentIndex].classList.remove('active');
    this.currentIndex = (newIndex + items.length) % items.length;
    items[this.currentIndex].classList.add('active');
    // opcional: reinicia el timer para no saltar inmediatamente
    clearInterval(this.intervalId);
    this.startCarousel(5000);
  }
  private startCarousel(intervalMs: number) {
    const container = document.querySelector('#carouselExampleIndicators .carousel-inner');
    const items = container?.querySelectorAll('.carousel-item') || [];

    // Asegura que el primero esté activo
    items.forEach((el, i) => el.classList.toggle('active', i === 0));

    this.intervalId = setInterval(() => {
      items[this.currentIndex].classList.remove('active');
      this.currentIndex = (this.currentIndex + 1) % items.length;
      items[this.currentIndex].classList.add('active');
    }, intervalMs);
  }
  UrlImagen(imagen: any): SafeUrl {
    return"data:image/png;base64," + imagen
  }

  getcaptcha() {

    this.authService.Getcapchat().subscribe(async resp => {
      if (resp.isSuccessful) {
        this.capchat$ = resp.result;
        this.RcaptchaGoogle = resp.result.captchaGogle
        this.RcaptchaSeven = resp.result.captchaSeven
        this.siteKey = resp.result.siteKey
        this.authentication = resp.result.authentication
        this.autenticacionOauth = resp.result.autenticacionOauth
        this.autenticacionAzure = resp.result.autenticacionAzure
        this.activeDirectory = resp.result.activeDirectory
        this.activeLDPA = resp.result.activeLDPA
        this.autenticationADpassword = resp.result.autenticationADpassword
        this.DfaGoogle = resp.result.dfaGoogle
        this.DfaMicrosoft = resp.result.dfaMicrosoft

        if(this.RcaptchaGoogle==true){
          const style = this.renderer.createElement('style');
          style.type = 'text/css';
          style.innerHTML = `
          .grecaptcha-badge {
            display: block !important;
        }
          `;
          this.renderer.appendChild(document.head, style);
        }


        if (this.autenticationADpassword === "S") {
          const myData = JSON.parse(localStorage.getItem('logout'));
     
          if (myData === "S") {
              localStorage.removeItem('logout');
              this._spinnerService.loading();
              await this.authService.logoutA(); // Cerrar sesión
              await this.authService.signOut(); // Asegúrate de que este método esté implementado correctamente
        
              // Iniciar sesión nuevamente
              await this.signIn(); // Llama a tu método de inicio de sesión
          } else {
              this._spinnerService.loading();
              await this.signIn(); // Llama a tu método de inicio de sesión
              return;
          }
      }


        if (resp.result.captchaSeven == true) {
          this.image = this.generateNew();
        }

      }
      else {

      }
    });


  }

  get verifyIsRemember(): any {
    let res = null;
    if (JSON.stringify(this.urlTree.queryParams) !== '{}' && this.urlTree.queryParams?.tkn) {
      res = this.urlTree.queryParams?.tkn;
    }
    return res;
  }
  verificarErrAuth() {
    let error = this._commonServices.getItemsessionStorage('errAuth');
    if (error) {
      Swal.fire({
        title: 'Seven',
        text: 'Error de inicio de sesión',
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Cancelar',
        cancelButtonText: 'No'
      });
      this._commonServices.removeItemsessionStorage('errAuth')
    }
  }
  // async sendLogin() {

  //   const autenticacionesActivas = [
  //     { tipo: 'autenticacionAzure', nombre: 'Azure' },
  //     { tipo: 'activeDirectory', nombre: 'Active Directory' },
  //     { tipo: 'activeLDPA', nombre: 'LDAP' }
  //   ];

  //   // Filtrar los tipos de autenticación que están activados
  //   const autenticacionesSeleccionadas = autenticacionesActivas.filter(auth => this[auth.tipo] === 'S');

  //   if (autenticacionesSeleccionadas.length > 1) {
  //     const nombresAutenticaciones = autenticacionesSeleccionadas.map(auth => auth.nombre).join(', ');
  //     this.messagesService.error('Seven ERP', `Tiene activada más de un tipo de autenticación: ${nombresAutenticaciones}. Por favor, valide con el administrador del sistema.`);
  //     return;
  //   }

  //   this._spinnerService.loading();
  //   this.loadLogin = true;
  //   if (!this.loginForm.get('password')?.value) {
  //     this.el.nativeElement.querySelector('#password').focus();
  //     this.loginForm.get('password')?.markAllAsTouched();
  //     this.loadLogin = false;
  //     this._spinnerService.close();
  //     return;
  //   }
  //   let dataLogin: login;
  //   dataLogin = {
  //     userName: this.usuario?.value,
  //     password: this.password?.value,
  //     companyId: '9',
  //     ambiente: this.ambiente?.value?.environmentId
  //   };
  //   if (dataLogin.password === '' || dataLogin.userName === '') {
  //     Swal.fire({
  //       title: 'Seven',
  //       text: 'Nombre de usuario y/o contraseña vacios.',
  //       showCloseButton: true,
  //       confirmButtonText: 'Ok'
  //     });
  //     this.loadLogin = false;
  //     this._spinnerService.close();
  //     return;
  //   }
  //   this.pass = dataLogin.password
  //   this.user = dataLogin.userName





  //   if (this.authentication == 'S') {
  //     // this.open(content)
  //   } else {
  //     if (this.RcaptchaSeven) {
  //       let result = await this.validate()
  //       if (result == false) {
  //         this.messagesService.error('Captcha', 'Captcha No Válido');
  //         return
  //       }
  //       else {
  //         this.opesession(this.pass, this.user);
  //         return
  //       }


  //     }
  //     if (this.RcaptchaGoogle == true) {
  //       if (this.RcaptchaGoogle == true) {
  //         // this.opesession(dataLogin.password, dataLogin.userName);
  //         this.reCaptchaService.execute('login').subscribe(async (tokenCaptcha: string)=>{
  //           //console.log("CaptchaToken",tokenCaptcha);
  //             this.tokenRequest.Token=tokenCaptcha;
  //             await this.validateReCaptcha(this.tokenRequest).pipe(
  //               catchError((error) => {
  //                 // Captura y maneja el error aquí
  //                 console.error('Error capturado:', error);
  //                 this.messagesService.error('Error en la validación del captcha: ' + (error.error?.message || 'Error desconocido'));
  //                 return throwError(() => error); // Reemite el error si es necesario
  //               })
  //             ).subscribe({
  //               next: (resp: any) => {
  //                 console.log("validateReCaptcha", resp);
  //                 if (resp.isSuccessful && resp.result) {
  //                   this.opesession(dataLogin.password, dataLogin.userName);
  //                 } else {
  //                   this.messagesService.error('Captcha No Válido');
  //                 }
  //               },
  //               error: (err) => {
  //                 // Aquí puedes manejar el error nuevamente si no lo hiciste en catchError
  //                 console.error('Error en la suscripción:', err);
  //               }
  //             });
              
            
  //         })
  //       }
  //       else {
  //         // this.messagesService.error('Captcha No Válido');
  //         return
  //       }

  //     }
  //     // else if(this.autenticacionAzure=='S')
  //     // {
  //     //    this.loginAzureAD();
  //     // }
  //     else if (!this.RcaptchaSeven && this.RcaptchaGoogle == false) {
  //       this.opesession(dataLogin.password, dataLogin.userName);
  //     }

  //   }


  // }


async sendLogin() {

  const autenticacionesActivas = [
    { tipo: 'autenticacionAzure', nombre: 'Azure' },
    { tipo: 'activeDirectory', nombre: 'Active Directory' },
    { tipo: 'activeLDPA', nombre: 'LDAP' }
  ];

  const autenticacionesSeleccionadas =
    autenticacionesActivas.filter(auth => this[auth.tipo] === 'S');

  if (autenticacionesSeleccionadas.length > 1) {
    this.showAuthenticationError(autenticacionesSeleccionadas);
    return;
  }

  this._spinnerService.loading();
  this.loadLogin = true;

  if (!this.validatePassword()) {
    return;
  }

  const dataLogin: login = {
    userName: this.usuario?.value,
    password: this.password?.value,
    companyId: '9',
    ambiente: this.ambiente?.value?.environmentId
  };

  if (!this.validateCredentials(dataLogin)) {
    return;
  }

  this.pass = dataLogin.password;
  this.user = dataLogin.userName;

  if (this.authentication === 'S') {
    return;
  }

  if (this.RcaptchaSeven) {
    await this.handleSevenCaptcha();
    return;
  }

  if (this.RcaptchaGoogle) {
    this.handleGoogleCaptcha(dataLogin);
    return;
  }

  this.opesession(dataLogin.password, dataLogin.userName);
}

private showAuthenticationError(authList: any[]): void {

  const nombres = authList.map(auth => auth.nombre).join(', ');

  this.messagesService.error(
    'Seven ERP',
    `Tiene activada más de un tipo de autenticación: ${nombres}. 
    Por favor, valide con el administrador del sistema.`
  );
}

private validatePassword(): boolean {

  if (this.loginForm.get('password')?.value) {
    return true;
  }

  this.el.nativeElement.querySelector('#password').focus();
  this.loginForm.get('password')?.markAllAsTouched();

  this.loadLogin = false;
  this._spinnerService.close();

  return false;
}

private validateCredentials(dataLogin: login): boolean {

  if (dataLogin.password && dataLogin.userName) {
    return true;
  }

  Swal.fire({
    title: 'Seven',
    text: 'Nombre de usuario y/o contraseña vacios.',
    showCloseButton: true,
    confirmButtonText: 'Ok'
  });

  this.loadLogin = false;
  this._spinnerService.close();

  return false;
}

private async handleSevenCaptcha(): Promise<void> {

  const result = await this.validate();

  if (!result) {
    this.messagesService.error('Captcha', 'Captcha No Válido');
    return;
  }

  this.opesession(this.pass, this.user);
}

private handleGoogleCaptcha(dataLogin: login): void {

  this.reCaptchaService.execute('login')
    .subscribe((tokenCaptcha: string) => {

      this.tokenRequest.Token = tokenCaptcha;

      this.validateReCaptcha(this.tokenRequest)
        .pipe(
          catchError((error) => {

            console.error('Error capturado:', error);

            this.messagesService.error(
              'Error en la validación del captcha: ' +
              (error.error?.message || 'Error desconocido')
            );

            return throwError(() => error);
          })
        )
        .subscribe({
          next: (resp: any) => {

            if (resp.isSuccessful && resp.result) {
              this.opesession(
                dataLogin.password,
                dataLogin.userName
              );
              return;
            }

            this.messagesService.error('Captcha No Válido');
          },

          error: (err) => {
            console.error('Error en la suscripción:', err);
          }
        });
    });
}
  ControlLicenciamiento(ctr_inic:string)
{
this._spinnerService.loading();

   
    
        const encryptedUser = encodeURIComponent(
  this.encryptRawBase64(this.user)
);

    const encryptedPass = encodeURIComponent(
  this.encryptRawBase64(this.pass)
);


  this.AuthHTTPService.ControlLicenciamiento(encryptedUser,encryptedPass,ctr_inic).subscribe(resp => {
    if (resp.isSuccessful) {
    
      this._router.navigate(['/dashboard']);
      this._spinnerService.close();
    }
    else {
     
         this.messagesService.confirmControl("Control de Licencia", resp.errorMessage, "warning")
    .then((result: any) => {
      if (result.isConfirmed) {    
         this._router.navigate(['/dashboard']);
         this._spinnerService.close();
   
      } 
    });

     

    }
  });
}

validarlicencia()
{
this._spinnerService.loading();
  this.AuthHTTPService.validatelicense().subscribe(resp => {
    if (resp.isSuccessful) {
   
      if (resp.result.length<=0) {
        this.popuplicen = true;
           this._spinnerService.close();
      }
      else{
        this.ControlLicenciamiento("N")
      }
     
    }
    else {
     
      this.messagesService.error(resp.errorMessage);
      this._spinnerService.close();
    }
  });
}

  onAccept() {
    this.popuplicen = false;
  

    this.ControlLicenciamiento("S")
  }

  onCancel() {
    this.popuplicen = false;

  }
  encryptRawBase64(plain: string): string {
    // Encriptar en CBC/PKCS7 y tomar el ciphertext raw (sin formato OpenSSL)
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plain), this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  
    // IMPORTANTE: tomar encrypted.ciphertext (WordArray) y convertirlo a base64
    const base64Cipher = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    return base64Cipher;
  }

  opesession(password: string, user: string) {
    // this.open(content);

    const encryptedUser = this.encryptRawBase64(user);
    const encryptedPass = this.encryptRawBase64(password);


    const loginSubscr = this.authService
      .login(encryptedUser, encryptedPass, this.valueatentication)
      .subscribe((user: UserModel) => {
        if (user) {

          this.user = user.username;
          this.mail = user.email;
          this.loadLogin = false;
          // this._router.navigate(['/pages']); 
          this.tokenSessio = user.accessToken;
         
          this.sessionData = user;

          if (this.autenticationADpassword === "N") {
            if (this.DfaGoogle === "S") {
              this.generar();
              this.popupVisible2sfGoogle = true;
            } else {
              this.loadLogin = false;
              this.saveSession();
              this.validarlicencia();
            }
          }


          this._commonServices.setItemsessionStorage('sessionData', user);

          this._commonServices.setItemsessionStorage('token', this.authService.getAuthFromLocalStorage().accessToken);

          this._spinnerService.close();

  

          if (this.autenticationADpassword == "S") {
            setTimeout(() => {
              this.saveSession();
              // this.cacheCall();
              this.loadLogin = false;
              this.validarlicencia();
            }, 100);
          }
          else {
            if (user.doubleauthentication == "N") {
              // this.session = false; 
              // this.router.navigate([this.returnUrl]);
            }
            else {


            }
          }
        }
      });

  }



  //Sincronizar outlook
  async signIn(): Promise<void> {

    const testPopup = window.open('', '', 'width=100,height=100');

    if (!testPopup || testPopup.closed || typeof testPopup.closed === 'undefined') {
      this.messagesService.WarningsS('Las ventanas emergentes están bloqueadas. Por favor habilítalas para continuar con el inicio de sesión.');
      
    } else {
      testPopup.close();
    this.sessionval = this.authService.valsession();
    this.valout = await this.authService.signInOu();;
    if (this.valout == 3) {
      this.messagesService.confirmAd('Por favor, inicie sesión con su usuario y contraseña de Directorio Activo.');
    }
    if (this.valout == 2) {
      this.messagesService.error('Error usuario logeado no es el mismo con el que se intenta realizar la sincronización');
    }
    else if (this.valout == 1) {
      this.opesessionoauthOutlook();
    }
  }
  }


  opesessionoauthOutlook() {
    // this.open(content);


    if (this.autenticationADpassword == "S") {
       this.opesession("AD",this.authService.user.email)

    }
    else {
      const loginSubscr = this.authService
        .login(this.authService.user.email, "", this.valueatentication)
        .subscribe((user: UserModel) => {
          if (user) {
            this.user = user.username;
            if (user.doubleauthentication == "N") {
              this.session = false;
              this.validarlicencia();
            }
            else {

              this.session = true;
            }
            // this.router.navigate([this.returnUrl]);
          }
        });


      this.unsubscribe.push(loginSubscr);
    }


  }

  saveSession() {
    let jsonEnviar = {
      Data: {
        sessionData: this.sessionData,
        requestMenu: null,
      },
    };

    this._commonServices.setItemlocalStorage('token', this.tokenSessio);
  }



  getFom() {
    if (!sessionStorage.getItem("listDeta_form")) {
      this.body = { estado: 'Idle', evento: 'OnQBE' };
      this.filtroQbeForms = { paginacion: { registrosporpagina: 0 } };

    }
    let formas = sessionStorage.getItem('List_form');
    this.body = { estado: 'Idle', evento: 'OnQBE' };
    if (!formas) {
      let filter = {
        "filtro": {
          "condition": "or",
          "rules": [
            {
              "field": 'tip_form',
              "operator": "=",
              "value": 'M'
            },
            {
              "field": 'tip_form',
              "operator": "=",
              "value": 'S'
            },
            {
              "field": 'tip_form',
              "operator": "=",
              "value": 'A'
            },
            {
              "field": 'tip_form',
              "operator": "=",
              "value": 'Q'
            },
            {
              field: 'tip_form',
              operator: '=',
              value: 'P',
            },
          ]
        }
      }

    }
  }



  singOnMethod($event: any) {
    if ($event.value) {
      this.methodId = $event?.value?.environmentId;
    } else {
      this.methodId = $event?.environmentId;
    }
    this._commonServices.setItemsessionStorage('methodId', this.methodId);
    if (this.ambiente?.value?.auth.method === 'saml2') {
      this.loginForm.controls["password"].setValue("");
      this.loginForm.controls["usuario"].setValue("");
      this.showGoogleBtn = true;
      this.showUsuario = false;
      this.showPasswordBtn = false;
      this.mostrarSend = false;
      this.mostrarContrasena = false;
    } else {
      if (this.mostrarContrasena === true) {
        this.showGoogleBtn = false;
        this.showUsuario = false;
        this.showPasswordBtn = true;
        this.mostrarSend = true;
      } else {
        this.showGoogleBtn = false;
        this.showUsuario = true;
        this.showPasswordBtn = true;
        this.mostrarSend = true;
      }
    }
  }
  googleSaml() {
    // location.href=`${this.urlSaml}?Value=${this.urlRedirect}`;
  }

  mostrarCampoPassword() {
    if (!this.loginForm.get('usuario')?.value) {
      this.el.nativeElement.querySelector('#usuario').focus();
      this.loginForm.get('usuario')?.markAllAsTouched();
      return;
    }
    this.showUsuario = false;
    this.mostrarAmbientes = false;
    this.mostrarContrasena = true;
    this.showBack = true;
  }

  backUser() {
    this.showUsuario = true;
    this.mostrarAmbientes = true;
    this.mostrarContrasena = false;
    this.showBack = false;
    this.loginForm.controls['password'].setValue("");
  }

  rememberUser() {
    this.showFormUser = !this.showFormUser;
  }
  listenRememberUser(event: any) {
    if (event?.back) {
      this.rememberUser();
    }

  }

  async generateNew(): Promise<Observable<any>> {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.authService.generate().subscribe(result => {
          if (result.txtError != "") {
          } else {
            this.captchaData.value = '';
            this.captchaData.base64 = result.objTransaction;
            this.image = this.captchaData.base64.replace('data:image/jpg;base64,', '');
            this.image = ('data:image/jpg;base64,') + (this.image.substring(0, 3) + this.image.substring(4, 6) + this.image.substring(7, 9) + this.image.substring(10, 12) + this.image.substring(13, 15) + this.image.substring(16, 18) + this.image.substring(19, 20) + this.image.substring(21, 23) + this.image.substring(24));
            // this.imageV.nes  = new type(arguments);(true) ;
            resolve(this.image);
          }
        });
      }, 1000);
    });
  }

  async validate(): Promise<boolean> {
    let valueC = false;
    return new Promise((resolve) => {
      setTimeout(() => {
        this.captchaData.value = this.captchavalueseven;
        if (this.captchaData.value && this.captchaData.value.length > 0) {
          this.authService.validate(this.captchaData).subscribe((resp: any) => {
            if (resp.retorno == 0) {
              this.ValueRcaptchaSeven = true;
              valueC = true;
              this.messagesService.success('Captcha', 'Captcha  Valido');
              // return valueC;
              resolve(valueC);
            }
            else {
              resolve(valueC);
            }
          })
        }
        else {
          resolve(valueC);
        }

      }, 1000);
    });




  }

  eventcaptcha(event: any) {
    this.captchavalueseven = event.target.value;

  }


  validateReCaptcha(token:TokenRequest)
  {
    return this.authService.validarToken(token);
  }


  generar()
  {

    this.authService.generateQRCode(this.user).subscribe((resp:any) => {
      this.secret = resp.secret;

      if(resp.qrCodeUrls=="false"){

      }
      else
      {
        this.qrCodeUri = `otpauth://totp/SevenERP:${encodeURIComponent(''+this.user+'')}?secret=${this.secret}&issuer=SevenERP&algorithm=SHA1&digits=6&period=30`;
      }
    
    });
  }
  onValidate(): void {
    // Enviar el código y la clave secreta para la validación
    if (this.code) {
      this.authService.validate2fa(this.code, this.secret).subscribe(
        response => {
          this.message = '¡Código válido! Acceso autorizado. Te redirigiremos a la aplicación Seven ERP en breve.';
          this.messageStyle = 'success'; // Establecer estilo de éxito
 
          setTimeout(() => {
            this.popupVisible2sfGoogle = false;
            this.loadLogin = false;
            this.saveSession();
            this.validarlicencia();
          }, 2000);
        },
        error => {
          this.message = 'Código inválido. Intenta de nuevo.';
          this.messageStyle = 'error'; // Establecer estilo de error
        }
      );
  }
}
}